import { PipelineDefinition } from './pipelineBuilder.types'

export const EMPTY_PIPELINE_DEFINITION: PipelineDefinition = {
    version: 1,
    steps: [],
}

export function cloneDefinition(
    definition: PipelineDefinition,
): PipelineDefinition {
    return JSON.parse(JSON.stringify(definition)) as PipelineDefinition
}
